import { createContext } from 'react';
export const HandleNavigationContext = createContext({handleNavigate: (to:any):void=>{}});
export const FadeContext = createContext({experience: true, projects: true, contact: true})